module.exports = "/static/fonts/fontawesome-webfont.b06871f.ttf";


//////////////////
// WEBPACK FOOTER
// ./font-awesome/fonts/fontawesome-webfont.ttf
// module id = 1127
// module chunks = 2